import { DocumentDesign } from "../api/types";
import { CanvasPaperConfig } from "../designer/PageDesigner/PageDesigner";
import { PaperOrientation } from "../designer/paper.constants";

export function getDocumentDesignPaperConfig(
  design: DocumentDesign,
): CanvasPaperConfig {
  return {
    height: JSON.parse(design.paper_config.paper_size).height,
    width: JSON.parse(design.paper_config.paper_size).width,
    paddingDirections: JSON.parse(design.paper_config.padding_directions),
    orientation: design.paper_config.orientation as PaperOrientation,
    pageBreakMargin: design.paper_config.page_break_margin ?? 0,
  };
}
